import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LandandbuildingsService } from './landandbuildings.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-landandbuildings',
  templateUrl: './landandbuildings.component.html',
  styleUrls: ['./landandbuildings.component.scss']
})
export class LandandbuildingsComponent implements OnInit {
  landform: FormGroup;
  APPeriodId: any;
  landid: any;
  tangibleAssetsValidation: any
  isJump: any;
  valueChanged: boolean; routeToCompanyList: boolean;
  NormalRoutng: boolean;
  showBubbledata:any

  constructor(private formbuilder: FormBuilder, private landservice: LandandbuildingsService, public commonService: CommonService, private router: Router, private sidenav: SideNavService) {
  }

  ngOnInit() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.createlandbuilding();
    this.getbuilding(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    this.valueChanges();
    this.clearfield();
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.APPeriodId).subscribe((data) => {
          debugger
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true)
            this.getlandbuildingLY()
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})
    if (localStorage.getItem("SubmitStatus") == "true")
      this.landform.disable();
    }

  createlandbuilding() {
    this.landform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      MasterId: new FormControl(),
      LandBuildingsId: new FormControl(),
      PropertyPlantEquipmentGrossCost_End: new FormControl(),
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_End: new FormControl(),
      PropertyPlantEquipment_Start: new FormControl(),
      PropertyPlantEquipment_End: new FormControl(),
      TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment: new FormControl(),
      DisposalsPropertyPlantEquipment: new FormControl(),
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start: new FormControl(),
      IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      PropertyPlantEquipmentGrossCost_Start: new FormControl(),
      PropertyPlantEquipmentFreeøtextComment: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }
  clear:any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.landform.reset()
      }
    })
  }

  insertlandbuilding() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.landform.controls['APPeriodId'].setValue(this.APPeriodId)
    this.landform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.landform.getRawValue()
    if (this.landid) {
      this.landform.controls['LandBuildingsId'].setValue(this.landid);
    }

    this.landservice.insertlandbuilding(formdata).subscribe((data) => {
      this.landform.markAsPristine();

      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Land and buildings", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == "landandbuildings") {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }
  getbuilding(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.landservice.getbuilding(this.APPeriodId).subscribe((data: any) => {
      if (data) {
        this.landform.patchValue(data);
        this.landform.controls['PropertyPlantEquipmentGrossCost_End'].disable();
        this.landform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_End'].disable();
        this.landform.controls['PropertyPlantEquipment_Start'].disable();
        this.landform.controls['PropertyPlantEquipment_End'].disable();
        this.landform.controls['TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment'].disable();
        this.landform.controls['DisposalsPropertyPlantEquipment'].disable();
        this.landform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start'].disable();
        this.landform.controls['IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
        this.landform.controls['DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
        this.landform.controls['PropertyPlantEquipmentGrossCost_Start'].disable();





 
        this.landid = data.LandBuildingsId
        this.costcalculations();
        this.depreciation();
      }
      this.commonService.getNotesData()
      this.commonService.gettotaltanagable()
    })
  }
  getlandbuildingLY() {
    debugger
    this.landservice.getbuildingly(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
      this.landform.controls['PropertyPlantEquipment_End'].setValue(data.PropertyPlantEquipment_End)
      

    })
  }

  valueChanges() {
    this.landform.valueChanges.subscribe((result) => {
      if (result) {
        if (this.landform.dirty) {
          this.valueChanged = true;
        }
      }
    })
  }
  save() {
    debugger
   // if (this.validations()) {
    if (true) {
      this.insertlandbuilding();
    }
    else {
      this.NormalRoutng = false;
      return false;
    }

  }
  back() {
    this.landform.markAsPristine();
    var backpage;
    //backpage = this.commonService.getBackSelection("Land and buildings", this.commonService.NotesList)
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Land and buildings", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }
  costcalculations() {
    //const propertyPlantEquipmentGrossCost_End = +this.landform.get("PropertyPlantEquipmentGrossCost_Start").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_End = +this.landform.get("TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment").value;
    //const propertyPlantEquipment_Start = +this.landform.get("DisposalsPropertyPlantEquipment").value;
    //const total = propertyPlantEquipmentGrossCost_End + accumulatedDepreciationImpairmentPropertyPlantEquipment_End;
    //this.landform.get("PropertyPlantEquipmentGrossCost_End").setValue(total - propertyPlantEquipment_Start);
    //this.landform.get("PropertyPlantEquipment_Start").setValue(this.landform.get("PropertyPlantEquipmentGrossCost_End").value - this.landform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);


  }

  depreciation() {
    //const totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment = +this.landform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start").value;
    //const disposalsPropertyPlantEquipment = +this.landform.get("IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_Start = +this.landform.get("DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const total = totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment + disposalsPropertyPlantEquipment;
    //this.landform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").setValue(total - accumulatedDepreciationImpairmentPropertyPlantEquipment_Start);
    //this.landform.get("PropertyPlantEquipment_Start").setValue(this.landform.get("PropertyPlantEquipmentGrossCost_End").value - this.landform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }


  validations() {
    debugger
    if (!this.commonService.MotorVehicles && !this.commonService.OfficeEquipment && !this.commonService.PlantMachinery && !this.commonService.Furnitureandfittings) {
      if (((this.landform.controls["PropertyPlantEquipment_Start"].value == "" || this.landform.controls["PropertyPlantEquipment_Start"].value == null) ? 0 : this.landform.controls["PropertyPlantEquipment_Start"].value) !=
        ((this.commonService.tangibleAssetsValidation.BalanceSheet_CY == null || this.commonService.tangibleAssetsValidation.BalanceSheet_CY == undefined) ? 0 : this.commonService.tangibleAssetsValidation.BalanceSheet_CY)) {
        Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.EndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.StartYear + " both values must match. ", 'warning')
        return false
      }
      if (((this.landform.controls["PropertyPlantEquipment_End"].value == "" || this.landform.controls["PropertyPlantEquipment_End"].value == null) ? 0 : this.landform.controls["PropertyPlantEquipment_End"].value) !=
        ((this.commonService.tangibleAssetsValidation.BalanceSheet_LY == null || this.commonService.tangibleAssetsValidation.BalanceSheet_LY == undefined) ? 0 : this.commonService.tangibleAssetsValidation.BalanceSheet_LY)) {
        Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.LastyearEndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.LastYear + " both values must match. ", 'warning')
        return false
      }
      else {
        return true
      }
    }
    else {
      return true
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.landform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data. </span><br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
